<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.qualitative_reports', 2),
                        href: null,
                    },
                    {
                        name: group.name,
                        href: meta.links.group_show,
                    },
                    {
                        name: student.full_name,
                        href: null,
                    },
                    {
                        name: $tc('messages.comments', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $t('messages.create'),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.update" method="post" @submit.prevent="submit">
            <TitleFieldsFormSection>
                <template v-slot:title> {{ $t('messages.trimester') }} {{ meta.info.trimester }} </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-12">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.comment')" for="comment" />
                            <FormTextarea
                                required
                                id="comment"
                                v-model="form.comment"
                                name="comment"
                                type="text"
                                rows="10"
                                class="w-full mt-1"
                                style="min-height: 100px"
                            />
                            <FormError :value="form.errors.comment" class="mt-2" />
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>
            <div class="flex justify-end mt-5">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormTextarea from '@/components/Forms/FormTextarea.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        PanelPage,
        TitleFieldsFormSection,
        FormTextarea,
        FormLabel,
        FormError,
        SubmitFormButton,
    },
    layout: Layout,
    name: 'Create',
    props: ['meta', 'options', 'student', 'group'],
    data() {
        return {
            form: this.$inertia.form({
                comment: '',
                trimester: this.meta.info.trimester,
            }),
        };
    },
    methods: {
        submit() {
            this.form.post(this.meta.links.store);
        },
    },
};
</script>
